/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { breadcrumbLinkMergeLeads } from "../lead-qualification-lead-list.constant";
import { BreadcrumbComponent } from "../../../common/components";
import LeadQualificationMergeLeadExactMatching from "./lead-qualification-merge-lead-exact-matching/lead-qualification-merge-lead-exact-matching";
import LeadQualificationMergeLeadFuzzyMatching from "./lead-qualification-merge-lead-fuzzy-matching/lead-qualification-merge-lead-fuzzy-matching";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import infoIcon from "../../../assets/icons/info-icon.svg";
import "./lead-qualification-merge-lead.scss";

const LeadQualificationMergeLeads = (props: any) => {
  const {
    setIsLeadQualificationMergeLeads,
    handleRefreshLeads,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    setLoading
  } = props;

  const [crumbMappingOption, setCrumbMappingOption] = useState<any>(
    breadcrumbLinkMergeLeads(setIsLeadQualificationMergeLeads)
  );
  const [mergingOption, setMergingOption] = useState<any>("Exact Matching");
  const [selectCriteria, setSelectCriteria] = useState<any>("primary_email_address");
  const [payloadInfo, setPayloadInfo] = useState<any>(null);
  const [isExactMatching, setIsExactMatching] = useState<any>(false);
  const [viewList, setViewList] = useState<any>(false);

  return (
    <div className="lead-qualification-merge-lead">
      {/* <div className="breadcrumb-wrapper"> */}
        <BreadcrumbComponent
          breadcrumbLink={crumbMappingOption}
          showBackArrow={false}
          handleBackArrowClick={() => {}}
        />
      {/* </div> */}
      <div className="lead-qualification-merge-lead-wrapper">
        <div className="lead-qualification-merge-lead-header">
          <div className="lead-qualification-merge-lead-header-title">
            Merge Duplicate Leads.
          </div>
          <div className="lead-qualification-merge-lead-header-subtitle">
            For merging, select between “Exact Match” or “Fuzzy Match” for
            accurate consolidation.
          </div>
        </div>
        <div className="lead-qualification-merge-lead-content">
          <div className="lead-qualification-merge-lead-content-checkbox">
            <div className="lead-qualification-merge-lead-radio-and-button-wrapper">
              <div className="lead-qualification-merge-lead-content-radio-section">
                <div className="lead-qualification-merge-lead-content-checkbox-main-title">
                  Merging Option :
                </div>
                <FormControl>
                  <RadioGroup row>
                    <FormControlLabel
                      value="Exact Matching"
                      control={
                        <Radio
                          onChange={() => {
                            setMergingOption("Exact Matching");
                            setViewList(false);
                            
                          }}
                          checked={mergingOption === "Exact Matching"}
                        />
                      }
                      label="Exact Matching"
                    />
                    <FormControlLabel
                      value="Fuzzy Matching"
                      control={
                        <Radio
                          onChange={() => {
                            setMergingOption("Fuzzy Matching");
                            setSelectCriteria("primary_email_address");
                            setViewList(false);
                          }}
                          checked={mergingOption === "Fuzzy Matching"}
                        />
                      }
                      label="Fuzzy Matching"
                    />
                  </RadioGroup>
                  </FormControl>
              </div>
              <div className="lead-qualification-merge-lead-content-list-button">
                <button
                  type="button"
                  onClick={() => {
                    setPayloadInfo({
                      mergingOption: mergingOption,
                      selectCriteria: selectCriteria,
                    });
                    setIsExactMatching(mergingOption === "Exact Matching");
                    setViewList(true);
                  }}
                >
                  See list of duplicates
                </button>
              </div>
            </div>
          </div>
          {mergingOption === "Fuzzy Matching" ?
            <div className="lead-qualification-merge-lead-content-sub-checkbox">
              <div className="lead-qualification-merge-lead-content-checkbox-main-title">
                Select Criteria :
              </div>
              <div>
                <FormControl>
                  <RadioGroup row>
                    <FormControlLabel
                      value="primary_email_address"
                      control={
                        <Radio
                          onChange={() => {
                            setSelectCriteria("primary_email_address");
                          }}
                          checked={selectCriteria === "primary_email_address"}
                        />
                      }
                      label="Email"
                    />
                    <FormControlLabel
                      value="primary_phone_number"
                      control={
                        <Radio
                          onChange={() => {
                            setSelectCriteria("primary_phone_number");
                          }}
                          checked={selectCriteria === "primary_phone_number"}
                        />
                      }
                      label="Phone Number"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
           : "" }
          <div className="lead-qualification-merge-lead-content-info">
            <div className="lead-qualification-merge-lead-content-info-section">
              <div className="lead-qualification-merge-lead-content-text-title-icon">
                <div className="lead-qualification-merge-lead-content-text-icon">
                  <img src={infoIcon} alt="info icon" />
                </div>
                <div className="lead-qualification-merge-lead-content-text-title">
                  <div className="lead-qualification-merge-lead-content-text-title-icon-maintitle">
                    Exact Matching
                  </div>
                  <div className="lead-qualification-merge-lead-content-text-title-icon-subtitle">
                    Use this to find duplicates that have the same details
                    entered, such as the same name, email, or contact number.
                    It's best when you're looking for clearly identical records.
                  </div>
                </div>
              </div>
            </div>
            <div className="lead-qualification-merge-lead-content-info-section">
              <div className="lead-qualification-merge-lead-content-text-title-icon">
                <div className="lead-qualification-merge-lead-content-text-icon">
                  <img src={infoIcon} alt="info icon" />
                </div>
                <div className="lead-qualification-merge-lead-content-text-title">
                  <div className="lead-qualification-merge-lead-content-text-title-icon-maintitle">
                    Fuzzy Matching
                  </div>
                  <div className="lead-qualification-merge-lead-content-text-title-icon-subtitle">
                    Use this when duplicate records might have small variations
                    like spelling differences or formatting changes. It helps
                    catch entries that look similar but aren’t exactly the same.
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="lead-qualification-merge-lead-content-list-button">
            <button
              type="button"
              onClick={() => {
                setPayloadInfo({
                  mergingOption: mergingOption,
                  selectCriteria: selectCriteria,
                });
                setIsExactMatching(mergingOption === "Exact Matching");
                setViewList(true);
              }}
            >
              See list of duplicates
            </button>
          </div> */}
        </div>
      </div>
      {viewList && (
        <div className="lead-qualification-merge-lead-wrapper-list">
          {isExactMatching ? (
            <LeadQualificationMergeLeadExactMatching
              setIsExactMatching={setIsExactMatching}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              setLoading={setLoading}
              setIsLeadQualificationMergeLeads={
                setIsLeadQualificationMergeLeads
              }
              handleRefreshLeads={handleRefreshLeads}
              payload={payloadInfo}
            />
          ) : (
            <LeadQualificationMergeLeadFuzzyMatching
              setIsExactMatching={setIsExactMatching}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              setLoading={setLoading}
              setIsLeadQualificationMergeLeads={
                setIsLeadQualificationMergeLeads
              }
              handleRefreshLeads={handleRefreshLeads}
              selectCriteria={selectCriteria}
              isExactMatching={isExactMatching}
              payload={payloadInfo}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default LeadQualificationMergeLeads;
